import { ReactElement, ReactNode } from 'react';
import { OrientationContent } from '../../styles';
import { colors } from 'styles/colors';
import { ApiResps } from 'providers';
import { useTranslation } from 'react-i18next';

interface ValidationInfoProps {
  validatedList: ApiResps['/energy/check-goals-batch']['LIST'];
}

export function ValidationInfo({
  validatedList,
}: Readonly<ValidationInfoProps>): ReactElement {
  const { t } = useTranslation();

  function renderErrorColumns(
    errors: ApiResps['/energy/check-goals-batch']['LIST'][number]['ERRORS'],
  ): string {
    return errors.map(
      (item) => (item.COLUMN === 'GOALS' ? 'Metas' : item.COLUMN),
    ).join(', ');
  }

  function renderErrorMessages(): ReactNode {
    const filteredList = validatedList.filter((item) => item.ERRORS.length > 0);

    return filteredList.map((item) => (
      <span
        style={{ color: colors.text['danger-base'] }}
        key={`validation-error-${item.UNIT_ID ?? ''}-${item.UNIT_NAME ?? ''}`}
      >
        {t('dadoDaUnidade')}
        {' '}
        <strong>
          {item.UNIT_NAME}
          {' - '}
          <i>{renderErrorColumns(item.ERRORS)}</i>
        </strong>
        {' '}
        {t('estaFormatoIncorretoFacaOAjuste')}
      </span>
    ));
  }

  return (
    <OrientationContent>
      <h3 style={{ color: colors.text['danger-base'] }}>
        {t('erroEnviarArquivo')}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {renderErrorMessages()}
        </div>
      </h3>

    </OrientationContent>
  );
}
